module.exports = __webpack_public_path__ + "img/dotfile.1c9a96b3.png";